import { useQuery } from '@tanstack/react-query'

import { UseBaseQueryOptions } from '@/core/api/type'
import { getInviteFriendReferredPlayers } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

import type {
	GetInviteFriendReferredPlayersRequest,
	GetInviteFriendReferredPlayersResponse,
} from '@/modules/manage-player/type'

export default function useQueryGetInviteFriendReferredPlayers(
	playerId: string,
	payload: GetInviteFriendReferredPlayersRequest,
	props?: UseBaseQueryOptions<GetInviteFriendReferredPlayersResponse>,
) {
	return useQuery({
		queryKey: [
			PlayerQueryKeys.GetInviteFriendReferredPlayers,
			playerId,
			payload,
		],
		queryFn: () => getInviteFriendReferredPlayers(playerId, payload),
		...props,
	})
}
